module.exports = __webpack_public_path__ + "52eb27b38f523a329c58952417b8c6b9.svg";